import { useNavigate } from 'react-router';
import { OnboardingHeader } from '../../components/OnboardingHeader';
import { PrimaryButton } from '../../components/PrimaryButton';
import { SecondaryButton } from '../../components/SecondaryButton';
import { ProActionButtons } from '../../components/ProActionButtons';
import { ProFooter } from '../../components/ProFooter';

export default function ProAboutEditPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <OnboardingHeader />

      <main className="flex-1 max-w-[520px] mx-auto w-full px-4 py-20 flex flex-col items-center">
        <h1 className="font-['Playfair_Display',sans-serif] font-bold text-[#8e2a2f] text-[24px] md:text-[34px] text-center mb-5">
          About me
        </h1>

        <div className="w-full bg-white rounded-[16px] border border-[#eee] p-6 mb-5">
          <textarea
            className="w-full h-[240px] font-['DM_Sans',sans-serif] text-[#3a3335] text-[16px] leading-[28px] focus:outline-none resize-none"
            defaultValue={`I am Selam, professional domestic cleaner in Newtown Birmingham. I work within 5 miles of my home. I offer house cleaning services, Classic one-off cleaning and Holiday rental cleaning services, at the time that suits you.

For a clean and tidy home, discover domestic cleaning with Selam`}
          />
        </div>

        <ProActionButtons saveLabel="Update" />
      </main>

      <ProFooter />
    </div>
  );
}
